import { render, staticRenderFns } from "./dataCompletion.vue?vue&type=template&id=5b3e6292&"
import script from "./dataCompletion.vue?vue&type=script&lang=js&"
export * from "./dataCompletion.vue?vue&type=script&lang=js&"
import style0 from "./dataCompletion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports